// Wishlist functionality
class Wishlist {
  constructor() {
    this.wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    this.counter = document.getElementById("wishlist-counter");
    this.initButtons();
    this.setInitialStates();
    this.updateCounter();
  }

  // Add this new method
  setInitialStates() {
    document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
      const productHandle = button.dataset.productHandle;
      if (this.isInWishlist(productHandle)) {
        button.classList.add("in-wishlist", "remove");
        button.setAttribute("aria-label", "Remove from wishlist");
      }
    });
  }

  updateCounter() {
    const count = this.wishlist.length || 0;
    this.counter.textContent = count;
    if (count === 0) {
      this.counter.classList.add("empty");
    } else {
      this.counter.classList.remove("empty");
    }
  }

  initButtons() {
    document.addEventListener("click", (e) => {
      const button = e.target.closest("[data-wishlist-toggle]");
      if (button) {
        e.preventDefault();
        const productHandle = button.dataset.productHandle;
        this.toggleProduct(productHandle, button);
      }
    });
  }

  toggleProduct(handle, button) {
    const index = this.wishlist.indexOf(handle);

    if (index > -1) {
      this.wishlist.splice(index, 1);
      button.classList.remove("in-wishlist", "remove");
      button.setAttribute("aria-label", "Add to wishlist");
    } else {
      // Add to wishlist
      this.wishlist.push(handle);
      button.classList.add("in-wishlist", "remove");
      button.setAttribute("aria-label", "Remove from wishlist");
    }

    this.updateCounter();
    localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

    // Dispatch a custom event
    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: {
          handle: handle,
          action: index > -1 ? "removed" : "added",
        },
      })
    );
  }

  isInWishlist(handle) {
    return this.wishlist.includes(handle);
  }
}

// Initialize everything when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  // Initialize global instances
  window.wishlist = new Wishlist();
});
